var map = {
	"./add-data.svg": 3193,
	"./app-health-connect.png": 72610,
	"./appointment.svg": 52990,
	"./arrow-down-black-filled.svg": 82383,
	"./arrow-down-gray-filled.svg": 75733,
	"./arrow-down-white-filled.svg": 71540,
	"./arrow-down.png": 43803,
	"./arrow-down.svg": 1313,
	"./arrow-dropdown.svg": 29571,
	"./arrow-gray.svg": 3117,
	"./arrow-left-long.svg": 60638,
	"./arrow-left-thin.svg": 59241,
	"./arrow-left.svg": 64210,
	"./arrow-long-up.svg": 16185,
	"./arrow-right-gray-filled.svg": 67349,
	"./arrow-right-link.svg": 35386,
	"./arrow-right.svg": 4776,
	"./arrow-up-white.svg": 34832,
	"./arrow-up.svg": 65277,
	"./back-arrow.svg": 85691,
	"./badge-round-checkmark.svg": 43265,
	"./badge-round-exclamation-point-secondary.svg": 96330,
	"./badge-round-exclamation-point.svg": 68353,
	"./badge-round-missing.svg": 73688,
	"./bell.svg": 71213,
	"./calendar-blue.svg": 25349,
	"./calendar-light-temp.svg": 4127,
	"./calendar-light.svg": 9019,
	"./calendar-v2.svg": 78131,
	"./calendar.svg": 16762,
	"./cam-closed-icon.svg": 27268,
	"./cam-open-icon.svg": 90705,
	"./campaign-message-alert.svg": 94757,
	"./campaign-message-answered.svg": 21148,
	"./campaign-message.svg": 33053,
	"./chat-gray.svg": 93961,
	"./chat-icon-disabled.svg": 13983,
	"./chat-icon.svg": 63665,
	"./check-active.svg": 1650,
	"./check-gray.svg": 59851,
	"./check-green.svg": 7504,
	"./check-inactive.svg": 58679,
	"./check-mark.svg": 45639,
	"./check-white.svg": 14241,
	"./circle-intervention-icon.svg": 23486,
	"./circle-med-change-icon.svg": 49957,
	"./close-20.svg": 6927,
	"./close-gray.svg": 53762,
	"./close-white.svg": 74410,
	"./close.svg": 37674,
	"./device-and-bp.png": 65251,
	"./device-and-scale.png": 37530,
	"./device-biointellisense.png": 65741,
	"./device-bodytrace-bp.png": 65663,
	"./device-bodytrace-scale.png": 44208,
	"./device-contec-pulseox.jpg": 17987,
	"./device-earlysense.png": 76782,
	"./device-emfit.png": 28832,
	"./device-general-bp-monitor.png": 16385,
	"./device-general-pulse-ox.png": 43170,
	"./device-general-scale.png": 92921,
	"./device-general.png": 30440,
	"./device-hub.jpg": 22452,
	"./device-nonin-pulseox.png": 40350,
	"./device-omron.jpg": 70274,
	"./device-vivalink.jpg": 29955,
	"./device-withings-bp.png": 89079,
	"./device-withings.jpg": 29868,
	"./device-yolanda.jpg": 45408,
	"./dotes.svg": 58070,
	"./edit-blue.svg": 46635,
	"./edu-pdf.svg": 82056,
	"./edu-url.svg": 27074,
	"./edu-youtube.svg": 33913,
	"./education-blue.svg": 57351,
	"./education.svg": 29369,
	"./email-bed.png": 91375,
	"./email-phone.png": 5396,
	"./email-scale.png": 11843,
	"./emergency.svg": 53363,
	"./emoji-1.svg": 5325,
	"./emoji-2.svg": 63574,
	"./emoji-3.svg": 39381,
	"./emoji-4.svg": 72745,
	"./emoji-5.svg": 28275,
	"./event-hospital-disabled.svg": 63030,
	"./event-hospital.svg": 10522,
	"./event-med-change-disabled.svg": 62136,
	"./event-med-change.svg": 15251,
	"./event-notes-disabled.svg": 54719,
	"./event-notes.svg": 17903,
	"./eye-white.svg": 87705,
	"./eye.svg": 76461,
	"./flag.svg": 57044,
	"./flip-camera.svg": 26702,
	"./focused-view.svg": 66661,
	"./follow-up-small.svg": 52691,
	"./gray-dot.svg": 69611,
	"./grid-view.svg": 74332,
	"./help-request-cancel-mark.svg": 31609,
	"./help-request-check-mark.svg": 55498,
	"./help-request-flag.svg": 25553,
	"./icon-alert.svg": 83564,
	"./icon-calendar-blue.svg": 40241,
	"./icon-calendar.svg": 84731,
	"./icon-edit.svg": 14614,
	"./icon-emojis.svg": 39446,
	"./icon-event-alert-red-sm.svg": 35778,
	"./icon-event-alert-red.svg": 29634,
	"./icon-event-alert-white.svg": 90963,
	"./icon-event-annotation.svg": 66550,
	"./icon-event-calendar-blue-sm.svg": 1663,
	"./icon-event-calendar-disabled.svg": 14674,
	"./icon-event-calendar-small.svg": 56895,
	"./icon-event-calendar.svg": 13158,
	"./icon-event-check-disabled.svg": 6988,
	"./icon-event-check.svg": 87446,
	"./icon-event-tagged-blue.svg": 21434,
	"./icon-event-tagged-white.svg": 62529,
	"./icon-follow-up-gray.svg": 25861,
	"./icon-follow-up.svg": 53132,
	"./icon-hospitalization.svg": 82255,
	"./icon-hr.svg": 34221,
	"./icon-intervention.svg": 96438,
	"./icon-med-change.svg": 34111,
	"./icon-notes.svg": 73358,
	"./icon-o2.svg": 58889,
	"./icon-personal-event.svg": 81742,
	"./icon-plus.svg": 75557,
	"./icon-pro.svg": 48556,
	"./icon-pulseRate.svg": 23991,
	"./icon-remove-blue.svg": 40792,
	"./icon-remove.svg": 31139,
	"./icon-reply.svg": 54563,
	"./icon-review.svg": 68566,
	"./icon-rr.svg": 12250,
	"./icon-sbp.svg": 21627,
	"./icon-sent.svg": 62433,
	"./icon-sleep.svg": 77322,
	"./icon-support-colored.svg": 89836,
	"./icon-support.svg": 71277,
	"./icon-task-check.svg": 88047,
	"./icon-timeline-notes.svg": 57992,
	"./icon-timeline-task.svg": 96554,
	"./icon-weight.svg": 55127,
	"./image-blue.svg": 66313,
	"./image.svg": 36949,
	"./info-icon.svg": 73359,
	"./like-icon-blue.svg": 93835,
	"./like-icon-white-down.svg": 45767,
	"./like-icon-white-up.svg": 74980,
	"./like-icon.svg": 37514,
	"./link-new.svg": 94667,
	"./link.svg": 90846,
	"./logo-reports.svg": 71330,
	"./logo.png": 74427,
	"./long-arrow-up.svg": 37786,
	"./medical-visit.svg": 91799,
	"./mic-mute-icon.svg": 2919,
	"./mic-open-icon.svg": 49455,
	"./myia-logo.svg": 54139,
	"./myia-video-logo.svg": 15642,
	"./new-window.svg": 10061,
	"./paperclip.svg": 64739,
	"./patient-default.svg": 52979,
	"./pdf.png": 2546,
	"./pen.svg": 64627,
	"./postpone.svg": 50562,
	"./provider-default.svg": 73184,
	"./read-receipt.svg": 84820,
	"./restore-icon.svg": 36254,
	"./reviewed-alert.svg": 80508,
	"./risk-ascending.svg": 41408,
	"./risk-descending.svg": 92922,
	"./role-anon.svg": 86116,
	"./search-gray.svg": 76533,
	"./search.svg": 73794,
	"./selected-checklist-item.svg": 93990,
	"./share-screen-icon.svg": 52769,
	"./side-bar-activity.svg": 26978,
	"./side-bar-care-plan.svg": 74185,
	"./side-bar-communication.svg": 84340,
	"./side-bar-events.svg": 6949,
	"./side-bar-minimize.svg": 53327,
	"./side-bar-profile.svg": 55373,
	"./side-bar-surveys.svg": 95449,
	"./side-bar-targets.svg": 83689,
	"./side-bar-thresholds.svg": 93653,
	"./social-facebook.png": 79564,
	"./social-twitter.png": 83349,
	"./sort-icon.svg": 31264,
	"./star-icon.svg": 31152,
	"./star.svg": 83111,
	"./survey-blue.svg": 33759,
	"./survey-check-badge.svg": 83738,
	"./survey-warning-badge.svg": 6625,
	"./survey.svg": 28157,
	"./tab-details.svg": 5791,
	"./take-picture.svg": 14284,
	"./target-icon-emoji.svg": 56248,
	"./target-icon-hr.svg": 26391,
	"./target-icon-o2.svg": 55724,
	"./target-icon-pulse-rate.svg": 2980,
	"./target-icon-rr.svg": 38066,
	"./target-icon-sbp.svg": 5799,
	"./target-icon-sleep.svg": 34797,
	"./target-icon-steps.svg": 65606,
	"./target-icon-weight.svg": 19183,
	"./telegram-plane.svg": 1942,
	"./to-do-list-blue-icon.svg": 90922,
	"./to-do-list-red-icon.svg": 180,
	"./to-do-list-yellow-icon.svg": 34883,
	"./triangle-down.svg": 9272,
	"./triangle-right.svg": 22282,
	"./triangle_down.png": 19710,
	"./triangle_up.png": 42739,
	"./user-default.svg": 79996,
	"./value-remove-red.svg": 77057,
	"./value-remove.svg": 77159,
	"./wand-blue.svg": 41240,
	"./wand.svg": 37287,
	"./warning-big-cleared-non-medical.svg": 30188,
	"./warning-big-non-medical.svg": 26328,
	"./warning-big.svg": 7829,
	"./warning-icon.svg": 27024,
	"./warning-medium-non-medical.svg": 8419,
	"./warning-medium.svg": 58677,
	"./warning-small.svg": 35793,
	"./watchlist-icon.svg": 32832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;